import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons/faArrowUpRightFromSquare';
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers';
import { faUserSecret } from '@fortawesome/free-solid-svg-icons/faUserSecret';
import { faBugSlash } from '@fortawesome/free-solid-svg-icons/faBugSlash';
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons/faRightFromBracket';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons/faCircleInfo';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { faLightbulb } from '@fortawesome/free-solid-svg-icons/faLightbulb';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons/faPaperPlane';

/**
 * Build menu options according the received parameters
 *
 * @param {object} account - Account object
 * @param {object} spoofing - Spoofing object
 * @param {string} appId - App ID
 * @param {function} toggleLaunchDebugger - Toggle launch debugger function
 * @param {function} logout - Logout function
 * @param {string} studioUrl - Studio URL (region-aware)
 * @returns {array} - Menu items options within their categories
 */
export const menuOptionsHandler = ({
  account,
  spoofing,
  appId,
  toggleLaunchDebugger,
  logout,
  studioUrl,
}) => {
  const { accountId, isAdmin, hasMultipleAccounts, toggleAccounts } = account;
  const { isSpoofing, toggleSpoofing } = spoofing;

  return [
    {
      headerLabel: 'Actions',
      items: [
        {
          icon: faArrowUpRightFromSquare,
          label: 'Appcues Dashboard',
          href: `${studioUrl}?account=${accountId}`,
        },
        hasMultipleAccounts && {
          icon: faUsers,
          label: 'Switch accounts',
          callback: toggleAccounts,
        },
        isAdmin &&
          isSpoofing === false && {
            icon: faUserSecret,
            label: 'Spoof account',
            callback: toggleSpoofing,
          },
        {
          icon: faBugSlash,
          label: 'Launch debugger',
          callback: toggleLaunchDebugger,
          disabled: !appId,
        },
        {
          icon: faRightFromBracket,
          label: 'Sign out',
          callback: logout,
        },
      ].filter(Boolean),
    },
    {
      headerLabel: 'Help',
      items: [
        {
          icon: faCircleInfo,
          label: 'Help docs',
          href: 'https://docs.appcues.com/',
        },
        {
          icon: faEnvelope,
          label: 'Contact support',
          href: 'mailto:support@appcues.com',
        },
        {
          icon: faLightbulb,
          label: 'Flow inspiration',
          href: 'https://www.reallygoodux.io',
        },
        {
          icon: faPaperPlane,
          label: "What's new",
          href: 'https://appcues.com/whats-new',
        },
      ],
    },
  ];
};
